
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class BatchQuantityInput extends Vue {
  @Model("input", { type: [String, Number] }) readonly value!: string | number;
  @Prop({ type: String, default: "Number of Animals Expected" }) readonly label!: string;
  @Prop({ type: Boolean, default: true }) readonly isRequired!: boolean;
  @Prop({ type: String, default: "Number of animals expected" }) readonly dialogTitle!: string;
  @Prop({ type: String, default: "" }) readonly displayLabel!: string;
  @Prop({ type: String, default: "outlined" }) readonly actionVariant!: "text" | "outlined";
  @Prop({ type: String, default: "primary" }) readonly saveColor!: string;
  @Prop({ type: [String, Number], default: 480 }) readonly maxWidth!: string | number;
  @Prop({ type: Boolean, default: false }) readonly isLocked!: boolean;

  dialog: boolean = false;
  draft: string = "";

  openDialog() {
    if (this.isLocked) {
      return;
    }

    this.draft = this.value ? String(this.value) : "";
    this.dialog = true;
    this.$nextTick(() => requestAnimationFrame(() => (this.$refs.batchQuantityInput as any)?.focus()));
  }

  closeDialog() {
    this.dialog = false;
  }

  @Watch("dialog")
  onDialogChanged(nextValue: boolean, previousValue: boolean) {
    if (previousValue && !nextValue) {
      this.$nextTick(() => requestAnimationFrame(() => (document.activeElement as HTMLElement | null)?.blur()));
    }
  }

  save() {
    this.$emit("input", this.draft);
    this.closeDialog();
  }

  blockInvalidNumberKeys(event: KeyboardEvent) {
    const invalidKeys = [69, 187, 188, 189, 190, 107, 109, 110];
    if (invalidKeys.includes(event.keyCode)) {
      event.preventDefault();
    }
  }
}
